// Sticky red banner rendered ABOVE the customer AppShell when an admin
// is impersonating a user. Non-dismissible by design — the only way out
// is the "Exit" button or the cookie expiring (4h). Even if Nick
// genuinely forgets the tab open, the cookie will time out on its own.
//
// Mounted at the top of the customer route tree (sibling to AppShell)
// so it sits ABOVE the DryRunBanner + topbar. AdminShell uses a
// DIFFERENT banner (its own red "SUPER-ADMIN" strip) since impersonation
// is only meaningful in the customer view.

import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FiEye, FiLogOut } from "react-icons/fi";
import { useExitImpersonation, useImpersonation } from "@/hooks/useSysadmin";

export default function ImpersonationBanner() {
  const { data } = useImpersonation();
  const exit = useExitImpersonation();
  const navigate = useNavigate();

  if (!data?.active || !data.target) return null;
  const { target } = data;

  return (
    <Box
      bg={{ base: "red.600", _dark: "red.700" }}
      color="white"
      px={{ base: 4, md: 8 }}
      py={2}
      position="sticky"
      top="0"
      zIndex={20}
      fontSize="sm"
    >
      <HStack justify="space-between" wrap="wrap" gap={2}>
        <HStack gap={2}>
          <FiEye />
          <Text fontWeight="medium">
            Viewing as {target.displayName ?? target.email}
            {target.displayName ? (
              <Text as="span" color="red.100" ml={2}>
                ({target.email})
              </Text>
            ) : null}
          </Text>
        </HStack>
        <Button
          size="xs"
          colorPalette="whiteAlpha"
          variant="solid"
          loading={exit.isPending}
          onClick={() =>
            exit.mutate(undefined, {
              onSuccess: () => navigate("/admin"),
            })
          }
        >
          <FiLogOut /> Exit
        </Button>
      </HStack>
    </Box>
  );
}
